export default __webpack_public_path__ + "static/media/FengCollectionEmpty.052561f9.jpg";